import useAuthUser from "@/composables/useAuthUser";
import EditPage from "@/modules/roles/pages/EditPage.vue";
import IndexPage from "@/modules/roles/pages/IndexPage.vue";
import { RouteRecordRaw } from "vue-router";

export default {
  path: "/roles",
  children: [
    {
      path: "",
      name: "roles.index",
      component: IndexPage,
    },
    {
      path: ":id",
      name: "roles.edit",
      component: EditPage,
    },
  ],
} as RouteRecordRaw;
